import { ScrollNumber } from "@modules/home/components";
import { trans } from "@mongez/localization";
import { useInView } from "framer-motion";
import { useRef } from "react";

/**
 * Impact statistics banner component
 * Displays key impact statistics in a horizontal banner
 */
export function ImpactStatsBanner() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  const stats = [
    {
      number: 2800,
      symbol: "+",
      description: trans("statsFamilies"),
    },
    {
      number: 2000,
      symbol: "+",
      description: trans("statsBeneficiaries"),
    },
    {
      number: 1000,
      symbol: "+",
      description: trans("statsEmployees"),
    },
    {
      number: 120,
      symbol: "+",
      description: trans("statsVolunteerHours"),
    },
    {
      number: 35,
      symbol: "%",
      description: trans("statsYouthPrograms"),
    },
    {
      number: 100,
      symbol: "%",
      description: trans("statsSafetyCommitment"),
    },
    {
      number: 300,
      symbol: "+",
      description: trans("statsUmrahEmployees"),
    },
  ];

  return (
    <div
      ref={ref}
      className="w-full bg-marine py-8 sm:py-10 md:py-12 lg:py-14 xl:py-16 3xl:py-20"
    >
      <div className="container">
        {/* Title */}
        <h2 className="mb-8 text-center text-2xl font-semibold tracking-[-0.03rem] text-white sm:mb-10 sm:text-3xl md:mb-12 md:text-[36px] lg:mb-10 lg:text-[38px] xl:mb-12 2xl:text-[42px] 3xl:mb-16 3xl:text-[42px]">
          {trans("impactInNumbers")}
        </h2>

        <div className="grid grid-cols-2 gap-8 sm:grid-cols-2 sm:gap-10 lg:grid-cols-3 lg:gap-5 xl:grid-cols-7 xl:gap-6 2xl:gap-8 3xl:gap-10">
          {stats.map((stat, index) => (
            <div
              className="col-span-1 flex flex-col items-center text-center last-of-type:max-md:col-span-3 last-of-type:max-sm:col-span-2"
              key={index}
            >
              <div className="flex items-end text-3xl font-bold leading-tight text-bright-orange sm:mb-3">
                <ScrollNumber
                  isInView={inView}
                  number={stat.number}
                  size="medium"
                />
                <span className="mb-2">{stat.symbol}</span>
              </div>
              <div className="px-2 text-center text-sm leading-relaxed text-white max-md:max-w-[200px] sm:text-base md:text-lg lg:text-sm xl:text-xs 2xl:text-sm 3xl:text-xl">
                {stat.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
